import ScreenSendPushNotification from 'screens/SendPushNotification';
import { SEND_PUSH_NOTIFICATION } from 'routes/paths';

const sendPushNotificationForm = [
  {
    path: SEND_PUSH_NOTIFICATION.FORM,
    name: 'SendPushNotificationForm',
    component: ScreenSendPushNotification,
    loginRequired: true,
    allowPermissions: [],
  },
];

export default sendPushNotificationForm;
